// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headingWithIcon":"_35vaQm","icon":"_25PFfG","headingWithImg":"_3DispB","headingWithMedia":"_1bjUc-","title":"_2PA66p","headingNoImg":"_5aM3Q","flex":"_3uiMNI"};